import React, { useState } from "react";
import Reveal from "./Reveal";
import { FAQS } from "../data/faq";
import { Plus, Minus } from "lucide-react";

export default function Faq({ limit }) {
  const [open, setOpen] = useState(0);
  const items = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <div className="space-y-3" data-testid="faq-list">
      {items.map((f, i) => {
        const isOpen = open === i;
        return (
          <Reveal
            key={i}
            className={`rounded-2xl border transition-all ${
              isOpen
                ? "bg-white border-[#3282B8] shadow-[0_14px_40px_-22px_rgba(15,76,117,0.4)]"
                : "bg-white border-[#E5E7EB]"
            }`}
          >
            <button
              onClick={() => setOpen(isOpen ? -1 : i)}
              data-testid={`faq-toggle-${i}`}
              className="w-full flex items-start justify-between gap-4 text-left px-5 md:px-7 py-5 md:py-6"
              aria-expanded={isOpen}
            >
              <span className="font-display font-bold text-base md:text-lg text-[#0F4C75] leading-snug">
                {f.q}
              </span>
              <span
                className={`shrink-0 mt-1 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                  isOpen
                    ? "bg-[#FF6B00] text-white"
                    : "bg-[#F8FAFC] text-[#0F4C75]"
                }`}
              >
                {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
              </span>
            </button>
            <div
              className={`grid transition-[grid-template-rows,opacity] duration-500 ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="px-5 md:px-7 pb-6 text-sm md:text-base text-[#1B262C]/75 leading-relaxed">
                  {f.a}
                </p>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
